import Image from 'next/image';

interface QuantaPointsProps {
  isPlus?: boolean;
  points: number;
}

const QuantaPoints: React.FC<QuantaPointsProps> = ({ isPlus = true, points }: QuantaPointsProps) => {
  return (
    <div className='flex items-center gap-1'>
      <div className='flex shrink-0'>
        <p className='text-lg font-semibold text-text-primary'>
          {isPlus && '+'} {points}
        </p>
      </div>
      <Image src='/assets/quanta/quanta-points.png' alt='Quanta Points' width={18} height={18} />
    </div>
  );
};

export default QuantaPoints;
